import { render, staticRenderFns } from "./UserDetailsContactInformationRevision.vue?vue&type=template&id=a4b84336&scoped=true&"
import script from "./UserDetailsContactInformationRevision.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsContactInformationRevision.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailsContactInformationRevision.vue?vue&type=style&index=0&id=a4b84336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b84336",
  null
  
)

export default component.exports